// NATIVE 
import { useCallback, useEffect, useRef, useState } from 'react';


// INSTALLED 
import Webcam from "react-webcam";
import Cropper from "react-easy-crop";
import { Area } from "react-easy-crop";
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Card, Divider, FormControlLabel, FormGroup, Grid, Icon, Paper, Slider, Switch, TextField, Typography } from '@mui/material';


// CUSTOM 
import { SnackAlert } from 'components/SnackAlert';
import InputField from 'components/formFields/InputField';
import InputNumeric from 'components/formFields/InputNumeric';
import { updateAvatarEmployeeStore, uploadFileImageFromCamera, uploadPdfStore } from 'store/uploaders';
import TextAreaField from 'components/formFields/TextAreaField';
import CheckboxField from 'components/formFields/checkBoxField';
import { IDatosBasicos } from 'commons/interfaces';
import DatePickerField from 'components/formFields/datePickerField';
import AutocompleteField from 'components/formFields/autocompleteField';
import { UploadButtonField } from 'components/formFields/uploadButtonField';
import { LinearProgressWithLabel } from 'components/LinearProgressWithLabel';
import { PreviewPdfButton } from 'components/PreviewPdfButton';
import { formatPhoneNumber, formatShortPhoneNumber } from 'commons/utils';
import { AvatarUsuariosPermissions } from 'components/AvatarUsuariosPermissions';
import { IconByString } from 'components/IconByString';
import { Visibility } from '@mui/icons-material';
import { DetailsComponents } from 'components/DetailsComponents';
import { ModalViewPdf } from 'components/modals/viwerPdf/ModalViewPdf';
import { set } from 'lodash';
import MultipleAlertSnackbars from 'components/MultipleAlertSnackbars';
import { LinearProgressWithLabelImagen } from 'components/LinearProgressWithLabelImagen';
import { EditarImgEmployeeActually } from '../../EditarImgEmployeeActually';
// import { EditarImgEmployeeActually } from 'components/stepers/EditarImgEmployeeActually';
// import { MultipleAlertSnackbars } from 'pages/talento-humano/employee/components/MultipleAlertSnackbars';




export const EditInformacionBasica = (props:any) => {


    // USE DISPATCH 
    const dispatch = useDispatch();


    // USE FORMIK CONTEXT 
    const formikProps:any = useFormikContext();


    // REDUX
    const  {  countries_list, sites_list }:IDatosBasicos  = useSelector( (state:any) => state.company );
    const  {  company, company_select }:any  = useSelector( (state:any) => state.company );
    
    const  {  sucursales_list_select }:any  = useSelector( (state:any) => state.sucursales );
    
    const  { cargos_list, cargos_select }  = useSelector( (state:any) => state.cargos );
    const  { type_documents_list, type_documents_list_select } = useSelector( (state:any) => state.tipodocumento );

    const  { employee }  = useSelector( (state:any) => state.employee );
    
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );

   
    const [typeDocument, setTypeDocument] = useState([]);

    const [countries,      setCountries]     = useState([]);
    const [departaments,   setDepartaments]  = useState([]);
    const [municipalies,   setMunicipalies]  = useState([]);
    const [cargos, setCargos] = useState([]);
    const [open, setOpen] = useState(true);
    // const [avatar, setAvatar] = useState(null)


    const [showCedulaDetail, setShowCedulaDetail] = useState(false);
    const [showCvDetail, setShowCvDetail] = useState(false);


    const [percentage_upload_cc, setPercentageUploadCc]   = useState(0);
    const [percentage_upload_cv, setPercentageUploadCv]   = useState(0);


    const [percentage_upload_img, setPercentageUploadImg]   = useState(0);

     const [percentage_upload, setPercntageUpload]   = useState(0);
    

     const [textAlertSnack, setTextAlertSnack] = useState('');
    const [severity, setSeverity] = useState('success');


    const [avatar, setAvatar] = useState(null);
    const [urlPdf, setUrlPdf] = useState<any>(null);
    const [urlCvPdf, setUrlCvPdf] = useState<any>(null);

    const [showCamera, setShowCamera] = useState(false);
    const [imgSrc, setImgSrc] = useState(null);
    

    // COMPAÑIA 
    const [company_formated, setCompanyFormated] = useState([]);



    const [withPhoto,  setWithPhoto] = useState(true);
    const [withImagen, setWithImagen] = useState(false);


    const [imgSrcUpload, setImgSrcUpload] = useState<any>(null);

    // ALERTS PARA CONFIGURACION SUBIR IMAGEN 
    const [alert_snack, setAlertSnack] = useState(false);
    const [alert_snack_company, setAlertSnackCompany] = useState(false);
    const [alert_snack_cargos, setAlertSnackCargos] = useState(false);







        // **************************************************************************
    // **************************************************************************
    //          // MANEJO IAMGEN CROP PHOTO
    // **************************************************************************
    // **************************************************************************           
    const [cropPhoto, setCropPhoto] = useState({ x: 0, y: 0 });
    const [zoomPhoto, setZoomPhoto] = useState(1);
    const [rotationPhoto, setRotationPhoto] = useState(0);
    // Estado nuevo para imagen recortada
    const [croppedImgPhoto, setCroppedImgPhoto] = useState<string | null>(null);
    

    const onCropCompletePhoto = useCallback((_: Area, croppedAreaPixelsPhoto: Area) => {
      setCroppedAreaPixelsPhoto(croppedAreaPixelsPhoto);
    }, []);

    const [croppedAreaPixelsPhoto, setCroppedAreaPixelsPhoto] = useState<Area>({
        x: 0,
        y: 0,
        width: 320,
        height: 240,
      });


    




      

    const handleSavePhoto = async() => {
    
          console.log('Intentando guardar recorte...');
          
          const imageSrc = imgSrc;
          
          // Verificación más específica
          if (!croppedAreaPixelsPhoto || !imageSrc) {
            console.log('No se puede guardar - faltan datos:', {
              tieneCroppedArea: !!croppedAreaPixelsPhoto,
              tieneImagen: !!imageSrc,
              imagen: imageSrc
            });
            return;
          }
    
          // Verifica que croppedAreaPixelsPhoto tenga dimensiones válidas
          if (croppedAreaPixelsPhoto.width <= 0 || croppedAreaPixelsPhoto.height <= 0) {
            console.log('Dimensiones de recorte inválidas:', croppedAreaPixelsPhoto);
            return;
          }
    
          console.log('Procesando imagen...');
          
          const image = new Image();
          image.src = imageSrc;
    
          image.onload = () => {
            console.log('Imagen cargada, dimensiones:', image.width, 'x', image.height);
            
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            if (!ctx) {
              console.log('Error: No se pudo obtener el contexto 2D');
              return;
            }
    
            canvas.width = croppedAreaPixelsPhoto.width;
            canvas.height = croppedAreaPixelsPhoto.height;
    
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate((rotationPhoto * Math.PI) / 180);
            ctx.translate(-canvas.width / 2, -canvas.height / 2);
    
            ctx.drawImage(
              image,
              croppedAreaPixelsPhoto.x,
              croppedAreaPixelsPhoto.y,
              croppedAreaPixelsPhoto.width,
              croppedAreaPixelsPhoto.height,
              0,
              0,
              croppedAreaPixelsPhoto.width,
              croppedAreaPixelsPhoto.height
            );
    
            canvas.toBlob( async(blob) => {
              if (blob) {
                const url = URL.createObjectURL(blob);
           
    
    
               const idEmployee =  formikProps.values.empleadoId;
    
               const result = await dispatch( updateAvatarEmployeeStore( 'avatar-employee',idEmployee, blob,  setPercntageUpload) );
    
               if( result.ok ){
    
                    setSeverity('success')
                    setTextAlertSnack(result.message);
                    setAlertSnack(true);
                    setAvatar(result.data);
                    // cancelPhoto();
                    afterSavePhoto();
                    
                    return false;
    
               }
           
                
              } else {
                console.log('Error: No se pudo crear el blob del recorte');
              }
            }, "image/jpeg");
          };
    
          image.onerror = () => {
            console.log('Error al cargar la imagen');
          };
          
        };


    //***************************************************************************
    // **************************************************************************
    //          FIN MANEJO IAMGEN CROP PHOTO FIN
    // **************************************************************************
    // ************************************************************************** 

















    
    
    // **************************************************************************
    // **************************************************************************
    //          // MANEJO IAMGEN CROP UPLOAD
    // **************************************************************************
    // **************************************************************************           
    const [cropUpload, setCropUpload] = useState({ x: 0, y: 0 });
    const [zoomUpload, setZoomUpload] = useState(1);
    const [rotationUpload, setRotationUpload] = useState(0);
    // Estado nuevo para imagen recortada
    const [croppedImgUpload, setCroppedImgUpload] = useState<string | null>(null);
    

    const onCropCompleteUpload = useCallback((_: Area, croppedAreaPixelsUpload: Area) => {
      setCroppedAreaPixelsUpload(croppedAreaPixelsUpload);
    }, []);

    const [croppedAreaPixelsUpload, setCroppedAreaPixelsUpload] = useState<Area>({
        x: 0,
        y: 0,
        width: 320,
        height: 240,
      });


    

    const handleSaveUpload = () => {
      console.log('Intentando guardar recorte...');
      
      const imageSrc = imgSrcUpload;
      
      // Verificación más específica
      if (!croppedAreaPixelsUpload || !imageSrc) {
        console.log('No se puede guardar - faltan datos:', {
          tieneCroppedArea: !!croppedAreaPixelsUpload,
          tieneImagen: !!imageSrc,
          imagen: imageSrc
        });
        return;
      }

      // Verifica que croppedAreaPixelsUpload tenga dimensiones válidas
      if (croppedAreaPixelsUpload.width <= 0 || croppedAreaPixelsUpload.height <= 0) {
        console.log('Dimensiones de recorte inválidas:', croppedAreaPixelsUpload);
        return;
      }

      console.log('Procesando imagen...');
      
      const image = new Image();
      image.src = imageSrc;

      image.onload = () => {
        console.log('Imagen cargada, dimensiones:', image.width, 'x', image.height);
        
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          console.log('Error: No se pudo obtener el contexto 2D');
          return;
        }

        canvas.width = croppedAreaPixelsUpload.width;
        canvas.height = croppedAreaPixelsUpload.height;

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((rotationUpload * Math.PI) / 180);
        ctx.translate(-canvas.width / 2, -canvas.height / 2);

        ctx.drawImage(
          image,
          croppedAreaPixelsUpload.x,
          croppedAreaPixelsUpload.y,
          croppedAreaPixelsUpload.width,
          croppedAreaPixelsUpload.height,
          0,
          0,
          croppedAreaPixelsUpload.width,
          croppedAreaPixelsUpload.height
        );

        canvas.toBlob(async(blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            console.log('Recorte guardado exitosamente:', url);
            
            const idEmployee =  formikProps.values.empleadoId;
    
               const result = await dispatch( updateAvatarEmployeeStore( 'avatar-employee',idEmployee, blob,  setPercntageUpload) );
    
               if( result.ok ){
    
                    setSeverity('success')
                    setTextAlertSnack(result.message);
                    setAlertSnack(true);
                    setAvatar(result.data);
                    // cancelPhoto();
                    afterSaveUpload();
                    
                    return false;
    
               }
               
          } else {
            console.log('Error: No se pudo crear el blob del recorte');
          }
        }, "image/jpeg");
      };

      image.onerror = () => {
        console.log('Error al cargar la imagen');
      };
      
    };


    //***************************************************************************
    // **************************************************************************
    //          FIN MANEJO IAMGEN CROP UPLOAD FIN
    // **************************************************************************
    // ************************************************************************** 







    const [percentage_upload_cedula, setPercentageUploadRut] = useState(0);



    const { formField: {
        // DATOS CLIENTE 
        e_document_type,
        e_expedition_place,
        e_file_img_upload,
        e_name,
        e_document_number,
        e_last_name,
        e_date_of_birth,
        e_gender,
        e_civil_status,
        e_landline,
        e_cell_phone,
        e_whatsapp,
        e_rh,
        e_dominance,
        e_allergies,
        e_cedula,
        e_housing_type,
        e_neighborhood,
        e_stratum,
        e_cost_center,
        e_compani,
        e_work_headquarters,
        e_cargo,
        e_cv,
        e_scholarship,
        e_institution,
        e_degree,
        e_address,
        e_email
      }
    } = props;



  
    useEffect(() => {

      if ( Object.keys(company).length > 0 && company.constructor === Object ) {
           
           const dataCompany:any = [{
               label: company.tradename,
               value: company.id

          }];

           setCompanyFormated(dataCompany);


           const dataCompanyDefault = {
              label: company.tradename,
              value: company.id
           }

           formikProps.setFieldValue('compani', dataCompanyDefault );
           
      }
      
    }, [company]);
    

    useEffect(() => {

        if (employee &&  Object.keys(employee).length > 0) {
            setEmployeeData(employee);
        }
    }, [employee]);
    

    

    useEffect(() => {
      if (employee && employee.employee_avatar) {
        setAvatar(employee.employee_avatar);
      }
    }, [employee])
    

    useEffect(() => {
      if (employee && employee.cedula_name_saved_name) {
          setUrlPdf(employee.cedula_name_saved_name);
      }
    }, [employee])

    
   useEffect(() => {
      if (employee && employee.cv_name_saved_name) {
          setUrlCvPdf(employee.cv_name_saved_name);
      }
    }, [employee])
    

    useEffect(() => {
        getDataInputesForm();
     }, []);
 
 
     useEffect(() => {
       setDepartaments(departaments_list);
     }, [departaments_list]);
 
     useEffect(() => {
       setMunicipalies(municipaly_list);
     }, [municipaly_list]);




    //  CARGOS 
     useEffect(() => {

      if ( cargos_list.length > 0 ) {

        const cargosList = cargos_list.map( (item:any) => {
              return {
                label: item.name, 
                value: item.id
              };
        });

        setCargos(cargosList);

      }
      

     }, [cargos_list]);
     


     const setEmployeeData = (employee:any) => {

        if (formikProps.values.is_initialized_info_basica) return;
        formikProps.setFieldValue('is_initialized_info_basica', true);

                // ID COMPANY 
            formikProps.setFieldValue('empleadoId', employee.id );

            


            if (employee.typeDocument && employee.typeDocument.type_document && employee.typeDocument.id) {
              formikProps.setFieldValue('e_document_type', { label: employee.typeDocument.type_document, value: employee.typeDocument.id });
            }
            if (employee.expedition_place) {
              formikProps.setFieldValue('e_expedition_place', employee.expedition_place);
            }
            if (employee.name) {
              formikProps.setFieldValue('e_name', employee.name);
            }
            if (employee.document_number) {
              formikProps.setFieldValue('e_document_number', employee.document_number);
            }
            if (employee.last_name) {
              formikProps.setFieldValue('e_last_name', employee.last_name);
            }
            if (employee.birthdate) {
              formikProps.setFieldValue('e_date_of_birth', employee.birthdate);
            }
            if (employee.gender) {
              formikProps.setFieldValue('e_gender', { label: employee.gender, value: employee.gender });
            }
            if (employee.civil_status) {
              formikProps.setFieldValue('e_civil_status', { label: employee.civil_status, value: employee.civil_status });
            }
            if (employee.landline) {
              formikProps.setFieldValue('e_landline', formatShortPhoneNumber(employee.landline));
            }
            if (employee.cell_phone) {
              formikProps.setFieldValue('e_cell_phone', formatPhoneNumber(employee.cell_phone));
            }
            if (typeof employee.whatsapp !== 'undefined') {
              formikProps.setFieldValue('e_whatsapp', employee.whatsapp);
            }
            if (employee.rh) {
              formikProps.setFieldValue('e_rh', { label: employee.rh, value: employee.rh });
            }
            if (employee.dominance) {
              formikProps.setFieldValue('e_dominance', { label: employee.dominance, value: employee.dominance });
            }
            if (employee.allergies) {
              formikProps.setFieldValue('e_allergies', employee.allergies);
            }
            if (employee.cedula) {
              formikProps.setFieldValue('e_cedula', employee.cedula);
            }
            if (employee.housing_type) {
              formikProps.setFieldValue('e_housing_type', { label: employee.housing_type, value: employee.housing_type });
            }
            if (employee.neighborhood) {
              formikProps.setFieldValue('e_neighborhood', employee.neighborhood);
            }
            if (employee.stratum) {
              formikProps.setFieldValue('e_stratum', employee.stratum);
            }


           
            
            let costCenterLabel = costCenter.find((item: any) => String(item.value) === String(employee.cost_center) || item.label === employee.cost_center)?.label;
            let costCenterValue = employee.cost_center;

            if (typeof employee.cost_center === 'object' && employee.cost_center !== null) {
                costCenterValue = employee.cost_center.id || employee.cost_center.value;
                costCenterLabel = employee.cost_center.name || employee.cost_center.label || costCenterValue;
            } else if (!costCenterLabel) {
                costCenterLabel = employee.cost_center;
            }

            formikProps.setFieldValue('e_cost_center', { label: costCenterLabel, value: costCenterValue });

            if (employee.company && employee.company.tradename && employee.company.id) {
              formikProps.setFieldValue('e_compani', { label: employee.company.tradename, value: employee.company.id });
            }

           
            if (employee.branch && employee.branch.name && employee.branch.id) {
              formikProps.setFieldValue('e_work_headquarters', { label: employee.branch.name, value: employee.branch.id });
            }
            if (employee.position && employee.position.name && employee.position.id) {
              formikProps.setFieldValue('e_cargo', { label: employee.position.name, value: employee.position.id });
            }
            if (employee.cv) {
              formikProps.setFieldValue('e_cv', employee.cv);
            }
            if (employee.scholarship) {
              formikProps.setFieldValue('e_scholarship', { label: employee.scholarship, value: employee.scholarship });
            }
            if (employee.institution) {
              formikProps.setFieldValue('e_institution', employee.institution);
            }
            if (employee.degree) {
              formikProps.setFieldValue('e_degree', employee.degree);
            }
            if (employee.address) {
              formikProps.setFieldValue('e_address', employee.address);
            }
            if (employee.email) {
              formikProps.setFieldValue('e_email', employee.email);
            }
            // DOCUMENTS
            if (employee.cedula_name_saved_name) {
              formikProps.setFieldValue('e_cedula_name_saved_name', employee.cedula_name_saved_name);
            }
            if (employee.cv_name_saved_name) {
              formikProps.setFieldValue('e_cv_name_saved_name', employee.cv_name_saved_name);
            }

            

            if ( formikProps.values.e_edit_foto_name_saved  ) {
                 formikProps.setFieldValue('e_foto_name_saved', formikProps.values.e_edit_foto_name_saved);
                 formikProps.setFieldValue('with_photo', true);
                 formikProps.setFieldValue('with_imagen', false);
                 setWithPhoto(true);  
                 setWithImagen(false);
                 setAvatar(null);
            } else if( formikProps.values.e_img_upload_name_saved ){
                 formikProps.setFieldValue('with_photo', false);
                 formikProps.setFieldValue('with_imagen', true);                                                    
                 formikProps.setFieldValue('e_foto_name_saved', formikProps.values.e_img_upload_name_saved);
                 setWithPhoto(false);  
                 setWithImagen(true);
                 setAvatar(null); 
            }else{
                formikProps.setFieldValue('e_foto_name_saved', employee.employee_avatar);
                formikProps.setFieldValue('with_photo', true);
            }
            

            // formikProps.setFieldValue('e_picture_photo_taked', employee.employee_avatar);
            
     }





     const getDataInputesForm = async () => {

        // console.log('sddddd')
        // const response = await dispatch( getFormsDataS() );

        
        // setCountries([]);
        // setDepartaments([]);
        // setMunicipalies([]);
    }


    
    const genderList =  [
      { label: 'Masculino', value: 'masculino'},
      { label: 'Femenino', value: 'Femenino'},
      { label: 'Otro', value: 'otro'}
    ];


    const maritalStatus =  [
      { label: 'Soltero', value: 'soltero'},
      { label: 'Casado', value: 'casado'},
      { label: 'Union Libre', value: 'unionlibre'},
      { label: 'Viudo', value: 'viudo'},
      { label: 'Separado', value: 'separado'}
    ];
    

    
    const bloodType =  [
      { label: 'AB+', value: 'AB+'},
      { label: 'AB-', value: 'AB-'},
      { label: 'A+', value: 'A+'},
      { label: 'A-', value: 'A-'},
      { label: 'B+', value: 'B+'},
      { label: 'B-', value: 'B-'},
      { label: 'O+', value: 'O+'},
      { label: 'O-', value: 'O-'}
    ];


    const domiNacion =  [
      { label: 'zurdo', value: 'zurdo'},
      { label: 'diestro', value: 'diestro'},
      { label: 'ambidiestro', value: 'ambidiestro'}
    ];

    
    const typeOfHousing =  [
      { label: 'propia', value: 'propia'},
      { label: 'alquiler', value: 'alquiler'},
      { label: 'familiar', value: 'familiar'},
      { label: 'ninguno', value: 'ninguno'},
    ];


    const costCenter =  [
      { label: 'administrativo', value: 'administrativo' },
      { label: 'mano de obra directa', value: 'mano de obra directa' },
      { label: 'mano de obra indirecta', value: 'mano de obra indirecta' },
      { label: 'operativo', value: 'operativo' },
      { label: 'ventas', value: 'ventas' },
    ];


    
    const escolaridadList =  [
      { label: 'primaria', value: 'primaria'},
      { label: 'bachillerato', value: 'bachillerato'},
      { label: 'tecnico', value: 'tecnico'},
      { label: 'tecnologo', value: 'tecnologo'},
      { label: 'postgrado', value: 'postgrado'},
    ];


    const uploadCedula = async({ target }:any) => {
    
      formikProps.setFieldValue('e_cedula', target.files[0]);
      const { ok, data } = await dispatch( uploadPdfStore( 'cedula-empleado', target.files[0], setPercentageUploadCc) );
      
      if (ok) {
      console.log('si pasooo', data)
        formikProps.setFieldValue('e_cedula_name_saved_name', data.pdfName);
      }

    }


  const uploadCV = async({ target }:any) => {
  
    formikProps.setFieldValue('e_cv', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'cv-empleado', target.files[0], setPercentageUploadCv) );
    
    if (ok) {
      formikProps.setFieldValue('e_cv_name_saved_name', data.pdfName);
    }

  }


  const uploadImagenCamera = async (imgSrc:any) => {

    // Convertir la imagen a un archivo Blob
    const blob = await fetch(imgSrc).then((res) => res.blob());

    // formikProps.setFieldValue('fileCajaCompensacion', target.files[0]);
    // const response = await dispatch( uploadFileImageFromCamera( 'avatar-employee', blob, setPercentageUploadCc) );
    
    // console.log('dejalo habla ', response)

    // if (!response.ok) {

    //   setImgSrc(null);
    //   formikProps.setFieldValue('e_foto_name_saved', null);
    //   setSeverity('error')
    //   setTextAlertSnack(response.errors[0]);
    //   setAlertSnack(true);
    //   return false;
    // }

    // if (response.ok) {

      //  formikProps.setFieldValue('e_foto_name_saved', response.data.imgName);
      //  formikProps.setFieldValue('e_edit_foto_name_saved', response.data.imgName);

      //  formikProps.setFieldValue('e_foto_name_saved', response.data.imgName);
       formikProps.setFieldValue('e_picture_photo_taked',URL.createObjectURL(blob) );

   
       formikProps.setFieldValue('e_img_upload_name_saved', null);


      //  formikProps.setFieldValue('e_foto_name_saved', response.data.imgName);
      //  setAvatar(null)

 
        // setSeverity('success')
        // setTextAlertSnack(response.message);
        // setAlertSnack(true);
        // return false;
    // }


    
  }


  
  
  const openCamera = () => {

    setShowCamera(!showCamera)
    setImgSrc(null);

 
    formikProps.setFieldValue('e_picture_photo_taked', null);
    setTimeout(() => {
       formikProps.setFieldValue('e_set_zoom_photo', 1);
    },1000);
    formikProps.setFieldValue('e_set_zoom_photo', 1);
  }


  const newPhoto = () => {

    setShowCamera(false)
  }


  const webcamRef:any = useRef(null);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    setShowCamera(false);
    uploadImagenCamera(imageSrc);
  }, [webcamRef]);


  const closeCamera = () => {

    setShowCamera(false)
    setAvatar(employee.employee_avatar);

    formikProps.setFieldValue('e_img_upload_name_saved', null);
    formikProps.setFieldValue('e_edit_foto_name_saved', null);


  }


  const afterSavePhoto = () => {
    
    formikProps.setFieldValue('e_img_upload_name_saved', null);
    formikProps.setFieldValue('e_edit_foto_name_saved', null);
    formikProps.setFieldValue('e_picture_photo_taked', null);
    setImgSrc(null);

  }

  
   const afterSaveUpload = () => {
    
    formikProps.setFieldValue('e_img_upload_name_saved', null);
    formikProps.setFieldValue('e_edit_foto_name_saved', null);
    formikProps.setFieldValue('e_picture_photo_taked', null); 

    formikProps.setFieldValue('e_imagen_uploaded_saved', null);
    formikProps.setFieldValue('e_edit_foto_name_saved', null);
    formikProps.setFieldValue('e_picture_photo_taked', null);
    setImgSrc(null);

  }
  
  const cancelPhoto = () => {

    setShowCamera(false)
    setAvatar(employee.employee_avatar);

    formikProps.setFieldValue('e_img_upload_name_saved', null);
    formikProps.setFieldValue('e_edit_foto_name_saved', null);
    formikProps.setFieldValue('e_picture_photo_taked', null);
    setImgSrc(null);
   
    formikProps.setFieldValue('e_set_zoom_photo', 1);

  }




  const cancelUpload = () => {

    setShowCamera(false)
    setAvatar(employee.employee_avatar);

    formikProps.setFieldValue('e_imagen_uploaded_saved', null);
    formikProps.setFieldValue('e_edit_foto_name_saved', null);
    formikProps.setFieldValue('e_picture_photo_taked', null);
    setImgSrc(null);
   
    formikProps.setFieldValue('e_set_zoom_upload', 1);
    setTimeout(() => {
      formikProps.setFieldValue('e_set_zoom_upload', 1);
    },1000);

  }


  const videoConstraints = {
    width: 320,
    height: 240,
    facingMode: "user"
  };



  useEffect(() => {

    ( company_select.length <= 0 ) ? setAlertSnackCompany(true) : setAlertSnackCompany(false);

  }, [company_select]);

  useEffect(() => {
    
    ( cargos_select.length <= 0 ) ? setAlertSnackCargos(true) : setAlertSnackCargos(false);

  }, [cargos_select]);
  


  const openCedulaDetail = () => {

    setShowCedulaDetail(!showCedulaDetail)
  }


  const openCvDetail = () => {

    setShowCvDetail(!showCvDetail)
  }
  



  const  isWithPhoto = (value:any) => {
  
        setWithPhoto(!withPhoto);
        setWithImagen(!withImagen);
      
        formikProps.setFieldValue('with_photo', !withPhoto);
        formikProps.setFieldValue('with_imagen', !withImagen);
      
  }


  const isWithImagen = (value:any) => {

      setWithPhoto(!withPhoto);
      setWithImagen(!withImagen);

      formikProps.setFieldValue('with_photo', !withPhoto);
      formikProps.setFieldValue('with_imagen', !withImagen);
  }



  const uploadImg = async({ target }:any) => {

     
  
        formikProps.setFieldValue('e_imagen_uploaded_saved', URL.createObjectURL(target.files[0]));

        const response = await dispatch( uploadFileImageFromCamera( 'avatar-employee', target.files[0], setPercentageUploadImg) );


        if (response.ok) {
          formikProps.setFieldValue('e_img_upload_name_saved', response.data.imgName);
          formikProps.setFieldValue('e_foto_name_saved', response.data.imgName);

          setImgSrcUpload(URL.createObjectURL(target.files[0]));
          
          formikProps.setFieldValue('e_imagen_uploaded_saved', URL.createObjectURL(target.files[0]));
          setAvatar(null);

      
          formikProps.setFieldValue('e_edit_foto_name_saved', null);



        }

  }



  return (
    <div>
 

        <SnackAlert open={alert_snack_cargos} autohidden={false} onclick={setAlertSnackCargos} text={'Aun no has creado los cargos'} severity={"warning"} />

        <SnackAlert open={alert_snack_company} autohidden={false} onclick={setAlertSnackCompany} text={'Aun no has creado la compañia'} severity={"warning"} />

        
        <SnackAlert open={alert_snack} onclick={setAlertSnack} text={textAlertSnack} severity={severity}/>



        {
          showCedulaDetail && <ModalViewPdf open={showCedulaDetail}  onClose={  setShowCedulaDetail } pdfUrl={urlPdf} />
        }

        {
          showCvDetail && <ModalViewPdf open={showCvDetail}  onClose={  setShowCvDetail } pdfUrl={urlCvPdf} />
        }
        

        {/* <MultipleAlertSnackbars /> */}
        <Grid container spacing={2}>
        
        
                 
        
        
              <Grid size={{ xs: 12 }} sx={{ marginTop: 3 }}>
                <Paper elevation={3} sx={{ padding: 2, borderRadius: 2, backgroundColor: '#f9f9f9' }}>
                  <FormGroup row sx={{ justifyContent: 'space-between' }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={withPhoto}
                          onChange={(_, checked) => { isWithPhoto(checked) }}
                          color="primary"
                        />
                      }
                      label="Con Foto"
                      sx={{ marginRight: 2 }}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={withImagen}
                          onChange={(_, checked) => { isWithImagen(checked) }}
                          color="primary"
                        />
                      }
                      label="Subir Imagen"
                    />
                  </FormGroup>
                </Paper>
              </Grid>
    
                
    
              
              {
                    withPhoto  &&  
    
                  <Grid size={{ xs: 12 }} sx={{ my: 3 }}>
                    <Paper elevation={4} sx={{ p: 3, borderRadius: 3, backgroundColor: '#f5f7fa', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'   }}>
                      
                      { formikProps.values.e_picture_photo_taked && (
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle1" sx={{ mb: 1 }}>
                            Vista previa de la foto:
                          </Typography>

                           {/* Mostrar Cropper si NO hay imagen recortada */}
                            <Box
                            sx={{
                              position: "relative",
                              width: 320,
                              height: 240,
                              background: "#333",
                              borderRadius: 2,
                              overflow: "hidden",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center"
                            }}
                          >
                            <Cropper
                              image={formikProps.values.e_picture_photo_taked }
                              crop={cropPhoto} // este sí puede seguir en useState
                              zoom={formikProps.values.e_set_zoom_photo || 1}
                              rotation={formikProps.values.set_rotation_photo || 0}
                              aspect={4 / 3}
                              objectFit="cover"
                              onCropChange={setCropPhoto}
                              onZoomChange={(z) => formikProps.setFieldValue('e_set_zoom_photo', z)}
                              onRotationChange={(r) => formikProps.setFieldValue('set_rotation_photo', r)}
                              onCropComplete={onCropCompletePhoto}
                                style={{
                                  containerStyle: {
                                    background: '#fff', // cambia el fondo del contenedor
                                  },
                                  mediaStyle: {
                                    background: '#fff', // evita el fondo negro al rotar
                                  },
                                }}
                            />


                          

                          </Box>

                                
                          {/* <img
                              src={ formikProps.values.e_picture_photo_taked ? formikProps.values.e_picture_photo_taked : undefined}
                            alt="webcam"
                            width={320}
                            height={240}
                            style={{ borderRadius: 8, border: '2px solid #ddd' }}
                          /> */}
                        </Box>
                      )}


                      { formikProps.values.e_picture_photo_taked && (
                      <Box sx={{ width: "60%", maxWidth: 300 }}>
                          <Typography gutterBottom align="center">Zoom</Typography>
                          <Slider
                            value={formikProps.values.e_set_zoom_photo || 1}
                            min={1}
                            max={3}
                            step={0.1}
                            onChange={(_, v) => formikProps.setFieldValue('e_set_zoom_photo', v)}
                          />

                          {/* <Typography gutterBottom align="center">Rotación</Typography>
                          <Slider
                            disabled
                            value={formikProps.values.set_rotation_photo || 0}
                            min={0}
                            max={360}
                            step={1}
                            onChange={(_, v) => formikProps.setFieldValue('set_rotation_photo', v)}
                          /> */}
                        </Box>
                        )}
    
                      {showCamera && (
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle1" sx={{ mb: 1 }}>
                            Cámara activa:
                          </Typography>
                          <Webcam
                            audio={false}
                            height={240}
                            ref={webcamRef}
                            screenshotFormat="image/png"
                            width={320}
                            videoConstraints={videoConstraints}
                            style={{ borderRadius: 8, border: '2px solid #ccc' }}
                          />
                        </Box>
                      )}
    
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 2, mt: 2 }}>
                        {imgSrc && (
                          <>
                            <Button variant="contained" onClick={openCamera} color="primary">
                              Tomar nueva foto
                            </Button>
                            <Button variant="contained" onClick={cancelPhoto} color="warning">
                              Cancelar
                            </Button>
                            <Button variant="contained" onClick={handleSavePhoto} color="success">
                              Actualizar imagen
                            </Button>
                          </>
                        )}
    
                        {!showCamera && !imgSrc && (
                          <Button variant="contained" onClick={openCamera} color="primary">
                            Encender cámara
                          </Button>
                        )}
    
                        {showCamera && (
                          <>
                            <Button variant="contained" onClick={closeCamera} color="primary">
                              Apagar cámara
                            </Button>
                            <Button variant="contained" onClick={capture} color="success">
                              Tomar foto
                            </Button>
                          </>
                        )}
                      </Box>
                    </Paper>
                  </Grid>
    
              }
              
              
              
              
              
            
            </Grid>


         
             {
                    withImagen &&  
                        <Grid size={{ xs: 12 }} sx={{ my: 3 }}>
      
                      
                        <Grid
                          size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                          sx={{
                            width: '100%',
                          }}
                        >
                          <Paper
                            elevation={3}
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              backgroundColor: '#f9f9f9',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
      
      {/* sdsd#$TG */}
                            
      
                            { withImagen && formikProps.values.e_imagen_uploaded_saved && (
                              <Box sx={{ mb: 2 }}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ mb: 1, display: 'flex', justifyContent: 'center', textAlign: 'center', width: '100%' }}
                                >
                                  Vista previa de la foto:
                                </Typography>


                                 <Box
                                sx={{
                                  position: "relative",
                                  width: 320,
                                  height: 240,
                                  background: "#333",
                                  borderRadius: 2,
                                  overflow: "hidden",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}
                              >
                               
                                {/* Mostrar Cropper si NO hay imagen recortada */}
                                {formikProps.values.e_imagen_uploaded_saved && (
                                 
                                   
                                  <Cropper
                                    image={formikProps.values.e_imagen_uploaded_saved}
                                    crop={cropUpload} // este sí puede seguir en useState
                                    zoom={formikProps.values.e_set_zoom_upload}
                                    rotation={formikProps.values.set_rotation_upload}
                                    aspect={4 / 3}
                                    objectFit="cover"
                                    onCropChange={setCropUpload}
                                    onZoomChange={(z) => formikProps.setFieldValue('e_set_zoom_upload', z)}
                                    onRotationChange={(r) => formikProps.setFieldValue('set_rotation_upload', r)}
                                    onCropComplete={onCropCompleteUpload}
                                  />
                                )}


                               


                                {/* Mostrar imagen recortada si EXISTE */}
                                {formikProps.values.picture_upload_taked && (
                                  <img
                                    src={formikProps.values.setCroppedImgUpload}
                                    alt="Recorte guardado"
                                    style={{ 
                                      width: '100%', 
                                      height: '100%', 
                                      objectFit: 'cover',
                                      borderRadius: 8 
                                    }}
                                  />
                                )}
                              </Box>
                                {/* <img
                                  src={ formikProps.values.e_imagen_uploaded_saved ? formikProps.values.e_imagen_uploaded_saved : undefined}
                                  alt="webcam"
                                  width={320}
                                  height={240}
                                  style={{ borderRadius: 8, border: '2px solid #ddd' }}
                                /> */}
      
                                {/* {
                                  imgSrcUpload && formikProps.values.e_imagen_uploaded_saved ?
                                    <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1  }}>
                                        <LinearProgressWithLabelImagen
                                          style={{flex: 1, flexWrap: 'wrap'}}
                                          percentage={percentage_upload_img}
                                          label={formikProps.values.e_imagen_uploaded_saved && formikProps.values.e_imagen_uploaded_saved.name ? formikProps.values.e_file_img_upload.name : ''}
                                          hasIcon={true}
                                        />
                                    </Card>
                                    :
                                    null
                                } */}


                                { formikProps.values.e_imagen_uploaded_saved && (
                                  <Box
                                  sx={{
                                    mt: 2,
                                    width: "100%",          // el contenedor ocupa todo
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",   // centra todo horizontalmente
                                  }}
                                >
                                
      
                                  <Box sx={{ width: "80%", maxWidth: 300 }}>
                                    <Typography gutterBottom align="center">Zoom </Typography>
                                    <Slider
                                      value={formikProps.values.e_set_zoom_upload || 1}
                                      min={1}
                                      max={3}
                                      step={0.1}
                                      onChange={(_, v) => formikProps.setFieldValue('e_set_zoom_upload', v)}
                                    />
      
                                    {/* <Typography gutterBottom align="center">Rotación</Typography>
                                    <Slider
                                      
                                      value={formikProps.values.set_rotation_upload || 0}
                                      min={0}
                                      max={360}
                                      step={1}
                                      onChange={(_, v) => formikProps.setFieldValue('set_rotation_upload', v)}
                                    /> */}
                                  </Box>
      
                                  
      
                                  {!formikProps.values.setCroppedImgUpload && (
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'center', mt: 2 }}>
                                      <Button variant="contained" onClick={cancelUpload} color="warning">
                                        Cancelar
                                      </Button>
                                      <Button variant="contained" color="success" onClick={handleSaveUpload}>
                                        Actualizar imagen
                                      </Button>
                                    </Box>
                                    
                                  )}
       
      
                                 </Box>
                                )}
                                
                              </Box>
                            )}
      
      
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ fontWeight: 600 }}
                            >
                              Subir Imagen
                            </Typography>
      
                            <UploadButtonField
                              accept={'image/*'}
                              name={e_file_img_upload.name}
                              label={e_file_img_upload.label}
                              text={'Seleccionar archivo'}
                              onChange={uploadImg}
                              style={{ marginTop: 10 }}
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                }


 

       
         
          
        
        {
          avatar && !formikProps.values.e_img_upload_name_saved && !formikProps.values.e_edit_foto_name_saved  && <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '4rem', marginTop: '1rem'}}>
          <EditarImgEmployeeActually urlImage={avatar} typeImage={'image-employee'} />
        </div>
        }
        

        <Grid container spacing={2}>

            <Grid size={{ xs: 3 }}> 

              {
                  
                  ( type_documents_list_select && Object.keys(type_documents_list_select).length > 0 )
                      ?
                      <AutocompleteField 
                        options={type_documents_list_select}
                        name={e_document_type.name}
                        label={e_document_type.label} 
                        element={e_document_type.name}
                        required={true}
                      />

                    //    <AutocompleteField  
                    //         options={areas_select}
                    //         name={e_area.name}
                    //         label={e_area.label}
                    //         element={area.name}
                    //     />
 
                      :
                      <InputField 
                       disabled
                       error
                       name={'N/A'}
                       label={'Debes crear los tipos de documentos*'}
                       variant="outlined" 
                       fullWidth
                      />
              }
                
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputNumeric 
                name={e_document_number.name}
                label={e_document_number.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={e_expedition_place.name}
                label={e_expedition_place.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={e_name.name}
                label={e_name.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>

        </Grid>
        {/* END GRID  */}



        
        <Grid container spacing={2} style={{ marginTop: 15 }}>

            <Grid size={{ xs: 3 }}>
              <InputField 
                name={e_last_name.name}
                label={e_last_name.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <DatePickerField label={e_date_of_birth.label} required={true}
                                      name={e_date_of_birth.name}/>
            </Grid> 
            <Grid size={{ xs: 3 }}>
                <AutocompleteField 
                   options={genderList}
                   name={e_gender.name}
                   label={e_gender.label}
                   required={true}
                   element={e_gender.name}
                />
            </Grid> 
            <Grid size={{ xs: 3 }}>
                <AutocompleteField 
                   options={maritalStatus}
                   name={e_civil_status.name}
                   label={e_civil_status.label}
                   required={true}
                   element={e_civil_status.name}
                />
            </Grid>

        </Grid>
        {/* END GRID  */}





        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={e_landline.name}
                label={e_landline.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={e_cell_phone.name}
                label={e_cell_phone.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }} >
                  
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                     <CheckboxField  name={e_whatsapp.name} label={e_whatsapp.label} required={true}/>
                  </div>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={e_email.name}
                label={e_email.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>

        </Grid>
        {/* END GRID  */}



        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 3 }}>
                <AutocompleteField 
                   options={bloodType}
                   name={e_rh.name}
                   label={e_rh.label}
                   required={true}
                   element={e_rh.name}
                />
            </Grid> 
            <Grid size={{ xs: 3 }}>
                <AutocompleteField 
                   options={domiNacion}
                   name={e_dominance.name}
                   label={e_dominance.label}
                   required={true}
                   element={e_dominance.name}
                />
            </Grid> 
            <Grid size={{ xs: 3 }}>
              <TextAreaField 
                name={e_allergies.name}
                label={e_allergies.label}
                required={true}
                placeholder="Ej. Ninguna, polen, etc."
                variant="outlined" 
                fullWidth
                />
            </Grid>
            <Grid size={{ xs: 3 }}>

               <div onClick={ openCedulaDetail }>
                  <DetailsComponents />
               </div>

               <UploadButtonField accept={'application/pdf'} 
                                  name={e_cedula.name} 
                                  label={e_cedula.label} 
                                  text={'Cedula'}  
                                  required={ !(formikProps.values.cedula || (formikProps.values.e_cedula_name_saved_name && !formikProps.values.e_cedula_name_saved_name.includes('dummy')) || (formikProps.values.cedula_name_saved_name && !formikProps.values.cedula_name_saved_name.includes('dummy'))) }
                                  onChange={uploadCedula}
                                  style={{ width: '100%' }}/>
                {
                   (formikProps.values.cedula || formikProps.values.e_cedula_name_saved_name || formikProps.values.cedula_name_saved_name)
                        ?
                         <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                          <LinearProgressWithLabel percentage={ (formikProps.values.e_cedula_name_saved_name || formikProps.values.cedula_name_saved_name) ? 100 : percentage_upload_cc } label={formikProps.values.cedula?.name || 'Cédula de ciudadanía'} hasIcon={true} /> 
                          {!(formikProps.values.e_cedula_name_saved_name?.includes('dummy') || formikProps.values.cedula_name_saved_name?.includes('dummy')) && (

      <PreviewPdfButton 
                              fileName={formikProps.values.e_cedula_name_saved_name || formikProps.values.cedula_name_saved_name} 
                              typeUrl="cedula-empleado" 
                              onOpenPdf={props.onOpenPdf} 
                            />
    )}
                         </Card>
                        :
                        ''
                }
            </Grid>

        </Grid>
        {/* END GRID  */}

        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10 }}>Datos Domiciliarios</Typography>



        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={e_address.name}
                label={e_address.label}
                required={true}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid size={{ xs: 3 }}>
                <InputField 
                  name={e_neighborhood.name}
                  label={e_neighborhood.label}
                  required={true}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>
            <Grid size={{ xs: 3 }}>
                <AutocompleteField 
                   options={typeOfHousing}
                   name={e_housing_type.name}
                   label={e_housing_type.label}
                   required={true}
                   element={e_housing_type.name}
                />
            </Grid>
            <Grid size={{ xs: 2 }}>
                <InputNumeric 
                  name={e_stratum.name}
                  label={e_stratum.label}
                  required={true}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>
        </Grid>
         {/* END GRID  */}


        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10 }}>Laboral</Typography>



        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 2 }}>
                <AutocompleteField 
                   options={costCenter}
                   name={e_cost_center.name}
                   label={e_cost_center.label}
                   required={true}
                   element={e_cost_center.name}
                />
            </Grid>
          
            <Grid size={{ xs: 3 }}>
               {
                  
             
                 ( company_select && Object.keys(company_select).length > 0 )
                     ?
                     <AutocompleteField 
                        options={company_select}
                        name={e_compani.name}
                        label={e_compani.label}
                        required={true}
                        element={e_compani.name}
                      />
                     :
                     <InputField 
                       name={'company'}
                      label={'Compañia'}
                      variant="outlined" 
                      fullWidth
                      defaultValue={formikProps.values.e_compani?.label ?? formikProps.values.e_compani ?? 'N/A'}
                      inputProps={{ readOnly: true }}
                     />
               }
               
            </Grid>
            
            <Grid size={{ xs: 2 }}>  
                <AutocompleteField 
                   options={sucursales_list_select}
                   name={e_work_headquarters.name}
                   label={e_work_headquarters.label}
                   required={true}
                   element={e_work_headquarters.name}
                />
            </Grid>
            <Grid size={{ xs: 3 }}>
                 
              {
                  
                  ( cargos_select && Object.keys(cargos_select).length > 0 )
                     ?
                      <AutocompleteField 
                        options={cargos_select}
                        name={e_cargo.name}
                        label={e_cargo.label}
                        required={true}
                        element={e_cargo.name}
                      />
                     :
                     <InputField 
                      disabled
                      error
                      name={'N/A'}
                      label={'Debes crear los cargos*'}
                      variant="outlined" 
                      fullWidth
                     />
               }

                
            </Grid>
            <Grid size={{ xs: 2 }}>

               <div onClick={ openCvDetail }>
                  <DetailsComponents />
               </div>
               <UploadButtonField accept={'application/pdf'} 
                                  name={e_cv.name} 
                                  label={e_cv.label} 
                                  text={'Hoja de vida'} 
                                  required={ !(formikProps.values.cv || (formikProps.values.e_cv_name_saved_name && !formikProps.values.e_cv_name_saved_name.includes('dummy')) || (formikProps.values.cv_name_saved_name && !formikProps.values.cv_name_saved_name.includes('dummy'))) }
                                  onChange={uploadCV}
                                  style={{ width: '100%' }}/>
                {
                   (formikProps.values.cv || formikProps.values.e_cv_name_saved_name || formikProps.values.cv_name_saved_name)
                        ?
                         <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                          <LinearProgressWithLabel percentage={ (formikProps.values.e_cv_name_saved_name || formikProps.values.cv_name_saved_name) ? 100 : percentage_upload_cv } label={formikProps.values.cv?.name || 'Hoja de vida'} hasIcon={true} /> 
                          {!(formikProps.values.e_cv_name_saved_name?.includes('dummy') || formikProps.values.cv_name_saved_name?.includes('dummy')) && (

      <PreviewPdfButton 
                              fileName={formikProps.values.e_cv_name_saved_name || formikProps.values.cv_name_saved_name} 
                              typeUrl="cv-empleado" 
                              onOpenPdf={props.onOpenPdf} 
                            />
    )}
                         </Card>
                        :
                        ''
                }
            </Grid>
        </Grid>
        {/* END GRID  */}



        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10 }}>Academico</Typography>



        <Grid container spacing={2} style={{ marginTop: 15 }}>

            <Grid size={{ xs: 3 }}>
                <AutocompleteField 
                   options={escolaridadList}
                   name={e_scholarship.name}
                   label={e_scholarship.label}
                   required={true}
                   element={e_scholarship.name}
                />
            </Grid>
            <Grid size={{ xs: 3 }}>
                <InputField 
                  name={e_institution.name}
                  label={e_institution.label}
                  required={true}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>
            <Grid size={{ xs: 3 }}>
                <InputField 
                  name={e_degree.name}
                  label={e_degree.label}
                  required={true}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>

        </Grid>

        {/* END GRID  */}





        

    </div>
  )
}
